import React, { useState } from "react";
import "./SelectChild.css";
import Hamburger from "../../Hamburger";
import SideNavbar from "../../SideNavbar";
import { Link } from "react-router-dom";
import axios from "axios";
import { useEffect } from "react";
import { isAutheticated, signout } from "../../Auth";
import swal from "sweetalert";

const SelectChild = () => {
  const token = isAutheticated();
  const [hamburgerOpen, setHamburgerOpen] = useState(false);
  const [totalChild, setTotalChild] = useState([]);
  const [type, setType] = useState(null);
  const [data, setData] = useState({ child_Id: "" });
  const [gradeList, setGradeList] = useState([]);
  const [selectedIds, setSelectedIds] = useState({
    grade_Id: "",
    gender: "",
  });
  const [schoolType, setSchoolType] = useState("");

  useEffect(() => {
    const fetchSchool = async () => {
      try {
        const schoolId = localStorage.getItem("schoolID");
        const resp = await axios.get(`/api/client/school/${schoolId}`);

        setSchoolType(resp.data.data.type);
      } catch (err) {
        console.error(err);
      }
    };

    fetchSchool();
  }, []);

  const toggleHamburger = () => setHamburgerOpen(!hamburgerOpen);

  const uniqueBy = (arr, key) => [
    ...new Map(arr.map((item) => [item[key], item])).values(),
  ];

  // Fetch house & grade (only needed for store)
  useEffect(() => {
    const fetchData = async () => {
      try {
        const schoolId = localStorage.getItem("schoolID");
        const [gradeResp] = await Promise.all([
          axios.get(`/api/schools/grade/individualschool/${schoolId}`),
        ]);
        
        setGradeList(uniqueBy(gradeResp.data.school_grades || [], "name"));

      } catch (err) {
        console.error(err);
      }
    };
    fetchData();
  }, []);

  // Fetch school type
  useEffect(() => {
    const getData = async () => {
      try {
        const savedSchoolId = localStorage.getItem("schoolID");
        const { data } = await axios.get(`/api/client/school/${savedSchoolId}`);
        setType(data.data.type ?? null);
      } catch (error) {
        console.error("Error fetching school data:", error);
      }
    };
    getData();
  }, []);

  // Fetch children (only needed for non-store)
  useEffect(() => {
    const getData = async () => {
      try {
        const resp = await axios.get(`/api/client/child`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setTotalChild(resp.data.data);
      } catch (error) {
        swal({
          title: "Warning",
          text: error?.response?.data?.message,
          icon: "error",
          button: "Close",
          dangerMode: true,
        });
      }
    };
    getData();
  }, [token]);

  const handleChange = (e) =>
    setData((prev) => ({ ...prev, [e.target.name]: e.target.value }));

  const handleDropdownChange = (e) => {
    const { name, value } = e.target;
    setSelectedIds((prev) => ({ ...prev, [name]: value }));
  };

  const isStore = type === "store";

  // store  → all 3 dropdowns filled
  // non-store → child selected
  const isFormComplete = isStore
    ? selectedIds.grade_Id && selectedIds.gender
    : data.child_Id;

  // store  → /product/store  + query params via route state
  // non-store → /product/:child_Id
  const navigateTo = isStore ? `/product/store` : `/product/${data.child_Id}`;

  const routeState = isStore
    ? {
        grade_Id: selectedIds.grade_Id,
        gender: selectedIds.gender,
        house_Id: selectedIds.house_Id,
      }
    : { child_Id: data.child_Id };

  return (
    <>
      <div className="product-main">
        {localStorage.getItem("schoolBanner") && (
          <img
            src={`${localStorage.getItem("schoolBanner")}`}
            alt=""
            width="100%"
            height="100%"
          />
        )}
      </div>

      <div className="mainproducts" style={{ minHeight: "50vh" }}>
        {/* ── Sidebar ── */}
        <div className="Productmenus">
          <div className="submain mt-4 ms-2">
            <Link
              to="/dashboard"
              style={{
                textDecoration: "none",
                color: "black",
                fontSize: "1.6rem",
              }}
            >
              Dashboard
            </Link>
            <p className="mt-3">
              <Link
                to="/select_child"
                style={{
                  textDecoration: "none",
                  fontSize: "1.1rem",
                  fontWeight: "600",
                  color: "blue",
                }}
              >
                Products
              </Link>
            </p>
            <p>
              <Link
                to="/order/history"
                style={{ textDecoration: "none", color: "black" }}
              >
                Order History
              </Link>
            </p>
            {schoolType !== "store" && (
              <p>
                <Link
                  to="/child/add"
                  style={{ textDecoration: "none", color: "black" }}
                >
                  Children
                </Link>
              </p>
            )}
            <p>
              <Link
                to="/support_system"
                style={{ textDecoration: "none", color: "black" }}
              >
                Support
              </Link>
            </p>
            <p className="mt-3">
              <Link
                to="/profile"
                style={{ textDecoration: "none", color: "black" }}
              >
                My Profile
              </Link>
            </p>
            <p onClick={() => signout()}>
              <Link style={{ textDecoration: "none", color: "black" }}>
                Logout
              </Link>
            </p>
          </div>
        </div>

        {/* ── Hamburger ── */}
        <div className="hamburger" onClick={toggleHamburger}>
          <Hamburger isOpen={hamburgerOpen} />
        </div>

        <SideNavbar hamburgerOpen={hamburgerOpen} />

        {/* ── Main Content ── */}
        <div className="content">
          <div className="page-title">
            {isStore ? "Select Filters" : "Select Child"}
          </div>

          <div className="mainBords">
            {/* ── Child (non-store only) ── */}
            {!isStore && (
              <>
                <p className="field-label">Child</p>
                <select
                  className="sc-select"
                  name="child_Id"
                  onChange={handleChange}
                  value={data.child_Id}
                >
                  <option value="">-- select --</option>
                  {totalChild &&
                    totalChild.map((item, index) => (
                      <option key={index} value={item?._id}>
                        {item?.name}
                      </option>
                    ))}
                </select>
                <hr className="sc-divider" />
              </>
            )}

            {/* ── Filters (store only) ── */}
            {isStore && (
              <>
                <p className="field-label">Filters</p>
                <div className="filter-grid">
                  <div>
                    <p className="filter-sublabel">Grade</p>
                    <select
                      className="sc-select"
                      name="grade_Id"
                      onChange={handleDropdownChange}
                      value={selectedIds.grade_Id}
                    >
                      <option value="">-- select --</option>
                      {gradeList.map((item, index) => (
                        <option key={index} value={item?._id}>
                          {item?.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div>
                    <p className="filter-sublabel">Gender</p>
                    <select
                      className="sc-select"
                      name="gender"
                      onChange={handleDropdownChange}
                      value={selectedIds.gender}
                    >
                      <option value="">-- select --</option>
                      <option value="boy">Boy</option>
                      <option value="girl">Girl</option>
                    </select>
                  </div>
                </div>
              </>
            )}

            {/* ── Button ── */}
            <Link
              style={{ textDecoration: "none" }}
              to={isFormComplete ? navigateTo : "/select_child"}
              state={routeState}
            >
              <button
                disabled={!isFormComplete}
                type="submit"
                className="sc-btn"
              >
                Get Products
              </button>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default SelectChild;
